@import "../../themes/stories.globals";

:host {
  display: block;
  height: 100%;
}
